import request from '@/utils/request';
export function createNotice(data) {
  return request({
    url: "/admin/notice",
    method: 'post',
    data: data
  });
}
export function fetchNotice(id) {
  return request({
    url: "/admin/notice/".concat(id),
    method: 'get'
  });
}
export function putNotice(data) {
  return request({
    url: "/admin/notice/".concat(data.id),
    method: 'put',
    data: data
  });
}
export function deleteNotice(id) {
  return request({
    url: "/admin/notice/".concat(id),
    method: 'delete'
  });
}
export function fetchNoticeList() {
  return request({
    url: '/admin/noticeList',
    method: 'get'
  });
}
export function fetchCategoryList() {
  return request({
    url: '/admin/categoryList',
    method: 'get'
  });
}